/**
 * Tiny ageing badge next to the B2B source chip on the Drafts page.
 *
 * Colour shifts with elapsed time so admins can triage stale quotes at
 * a glance:
 *   • 0–2 days  → gray  (fresh)
 *   • 3–7 days  → amber (follow up soon)
 *   • >7 days   → red   (urgent / stale)
 *
 * Renders nothing if `iso` is falsy so the parent doesn't need a guard.
 */
import { Clock } from 'lucide-react';

const BUCKETS = [
    { max: 2, cls: 'bg-gray-50  text-gray-500  border-gray-200',  hint: 'Fresh — still inside the comfort window' },
    { max: 7, cls: 'bg-amber-50 text-amber-700 border-amber-200', hint: 'Cooling — time for a follow-up call' },
    { max: Infinity, cls: 'bg-red-50 text-red-700 border-red-200', hint: 'Stale — buyer patience likely gone' },
];

const formatLabel = (days) => {
    if (days <= 0) return 'today';
    if (days === 1) return '1d ago';
    return `${days}d ago`;
};

export const AgeBadge = ({ iso, testid }) => {
    if (!iso) return null;
    const ms = Date.now() - new Date(iso).getTime();
    if (Number.isNaN(ms)) return null;
    const days = Math.max(0, Math.floor(ms / (24 * 60 * 60 * 1000)));
    const bucket = BUCKETS.find((b) => days <= b.max);
    return (
        <span
            data-testid={testid}
            title={`${bucket.hint} (submitted ${new Date(iso).toLocaleString()})`}
            className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[1.5px] font-sans border rounded-full px-2 py-0.5 ${bucket.cls}`}
        >
            <Clock size={9} />
            {formatLabel(days)}
        </span>
    );
};

export default AgeBadge;
